import { create, type StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';

const createStore = <T>(store: StateCreator<T>, name: string) => {
  const isDev = import.meta.env.DEV;

  return isDev
    ? create<T>()(devtools(store, { name }))
    : create<T>()(store);
};

export { createStore };